import { theme } from "ant-design-vue";
import defaultSeed from "ant-design-vue/es/theme/themes/seed";
import type { SeedToken } from "ant-design-vue/es/theme/internal";
import type { ThemeConfig } from "ant-design-vue/es/config-provider/context";

const { defaultAlgorithm } = theme;

export const BASE_THEME_SEED: Partial<SeedToken> = {
  colorPrimary: "#00B96B",
  fontFamily: "Open Sans",
  fontSize: 12,
  borderRadius: 10,
};

export const getAntdComputedTokens = (
  seed: Partial<SeedToken> = BASE_THEME_SEED,
  algorithm: ThemeConfig["algorithm"] = defaultAlgorithm,
) => {
  const mergedSeed: SeedToken = {
    ...defaultSeed,
    ...seed,
  };

  const resolvedAlgorithm = Array.isArray(algorithm) ? algorithm[0] : algorithm;

  return resolvedAlgorithm(mergedSeed);
};
